import axios from "axios";

export const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
});

let onSessionExpired = null;
export function setSessionExpiredHandler(fn) {
  onSessionExpired = fn;
}

// Salute del server: "wanted-api-down" quando il server non risponde o 5xx, "wanted-api-ok" a ogni risposta buona
const segnalaServer = (ok) => { try { window.dispatchEvent(new Event(ok ? "wanted-api-ok" : "wanted-api-down")); } catch {} };

let refreshPromise = null;

api.interceptors.response.use(
  (response) => { segnalaServer(true); return response; },
  async (error) => {
    const original = error.config || {};
    const url = original.url || "";
    const status = error.response?.status;
    // Server irraggiungibile o 5xx (ma NON la manutenzione, che è una scelta): avvisa il banner
    const isMaintenance = error.response?.data?.code === "MAINTENANCE";
    if ((!status || status >= 500) && !isMaintenance) segnalaServer(false);
    const isAuthCall = ["/auth/login", "/auth/register", "/auth/refresh", "/auth/logout"].some((p) => url.includes(p));
    if (status === 401 && !original._skipRefresh && !original._retried && !isAuthCall) {
      original._retried = true;
      try {
        if (!refreshPromise) {
          refreshPromise = api.post("/auth/refresh", null, { _skipRefresh: true }).finally(() => { refreshPromise = null; });
        }
        await refreshPromise;
        return api(original);
      } catch {
        if (onSessionExpired) onSessionExpired();
      }
    }
    return Promise.reject(error);
  }
);

export function formatApiError(detail) {
  if (detail == null) return "Qualcosa è andato storto. Riprova.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const fmt = (n) =>
  Number(n).toLocaleString("it-IT", { style: "currency", currency: "EUR" });

// Preorder: acquistabile SOLO dalla data di apertura in poi; senza data non è mai acquistabile ("nodate")
export const preorderGate = (p) => {
  if (!p?.is_preorder) return null;
  const today = new Date().toLocaleDateString("sv-SE");
  if (p.preorder_date && p.preorder_date <= today) return null; // preorder aperti
  return p.preorder_date || "nodate";
};
export const preorderGateLabel = (p) => {
  const g = preorderGate(p);
  if (!g) return null;
  return g === "nodate" ? "Preorder non ancora aperti" : `I preorder aprono il ${new Date(g + "T12:00:00").toLocaleDateString("it-IT", { day: "numeric", month: "long" })}`;
};

export const GAME_STYLES = {
  "Pokémon": "bg-amber-500 text-white",
  "Magic: The Gathering": "bg-indigo-500 text-white",
  "Yu-Gi-Oh!": "bg-red-600 text-white",
  "One Piece": "bg-orange-500 text-white",
  "Lorcana": "bg-emerald-500 text-white",
  "Riftbound": "bg-purple-500 text-white",
};

export const GAMES = ["Tutti", "Pokémon", "Magic: The Gathering", "Yu-Gi-Oh!", "One Piece", "Lorcana"];

// Colori dei badge lingua sulle card prodotto (catalogo e scheda)
export const LANG_STYLES = {
  ITA: "bg-emerald-500 text-white",
  ENG: "bg-sky-500 text-white",
  JPN: "bg-rose-500 text-white",
  JAP: "bg-rose-500 text-white",
  FRA: "bg-indigo-500 text-white",
  FRE: "bg-indigo-500 text-white",
  DEU: "bg-amber-500 text-white",
  GER: "bg-amber-500 text-white",
  ESP: "bg-orange-500 text-white",
  SPA: "bg-orange-500 text-white",
  KOR: "bg-violet-500 text-white",
  ZH: "bg-red-600 text-white",
  CHN: "bg-red-600 text-white",
  POR: "bg-teal-500 text-white",
};
export const langStyle = (l) => LANG_STYLES[(l || "").toUpperCase()] || "bg-zinc-600 text-white";
export const ESPORTS_GAMES = ["EA FC 27", "Tekken 8", "Street Fighter 6", "Fortnite", "Mario Kart 8 Deluxe", "Super Smash Bros. Ultimate", "Altro"];
export const TCG_CATEGORIES = ["Singole", "Bustine Singole", "Collezioni Speciali", "Display Buste", "Mazzi", "Case"];
export const PRODUCT_LANGUAGES = ["ITA", "ENG", "JAP", "CHN", "KOR", "FRA", "GER", "SPA", "POR"];
export const ACCESSORY_CATEGORIES = ["Album", "Deck e Storage Box", "Sleeve Protettive", "Playmat", "Espositori e Toploader"];
export const PRODUCT_CATEGORIES = [...TCG_CATEGORIES, ...ACCESSORY_CATEGORIES];

export const STORE = {
  name: "WANTED Torino - Zona Lingotto",
  shortName: "Torino Lingotto",
  address: "Via Millefonti 28/a, 10126 Torino",
  hours: "Lun–Sab 10:00–20:00 • Dom 11:00–19:00",
  phone: "",
  email: "info@wantedtcg.it",
};

export const SOCIALS = [
  { id: "tiktok", label: "TikTok", href: "https://tiktok.com/@wanted.tcg" },
  { id: "instagram", label: "Instagram", href: "https://instagram.com/wanted.tcg" },
  { id: "facebook", label: "Facebook", href: "https://facebook.com/wantedtcg" },
  { id: "cardmarket", label: "Cardmarket", href: "https://www.cardmarket.com" },
  { id: "cardtrader", label: "CardTrader", href: "https://www.cardtrader.com" },
  { id: "ebay", label: "eBay", href: "https://www.ebay.it" },
];

export const GRADING_COMPANIES = ["PSA", "BGS", "CGC", "SGC"];
